import React, { useState } from 'react'
import { styled } from 'linaria/react'
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'
import { Above } from '@jetshop/ui/Breakpoints'

const CarouselWrapper = styled.div`
  position: relative;
`

const ArrowWrapper = styled.div`
  .arrow {
    width: 26px;
    height: 52px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    fill: #195178;
    cursor: pointer;
    z-index: 10;
    transition: opacity 0.3s ease;
  }

  .arrow > path {
    fill: #195178;
  }

  .arrow--left {
    left: -1rem;
  }

  .arrow--right {
    left: auto;
    right: 0rem;
  }

  .arrow--disabled {
    fill: rgba(255, 255, 255, 0.5);
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
  }

  .arrow:hover:not(.arrow--disabled) {
    opacity: 0.8;
  }
`

function Arrow(props) {
  const disabled = props.disabled ? ' arrow--disabled' : ''
  
  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    
    if (!props.disabled && props.onClick) {
      props.onClick(e)
    }
  }
  
  return (
    <Above breakpoint="lg">
      <svg
        onClick={handleClick}
        className={`arrow ${
          props.left ? 'arrow--left' : 'arrow--right'
        }${disabled}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={props.left ? '0 0 11 19' : '0 0 14 23'}
        style={{ cursor: props.disabled ? 'not-allowed' : 'pointer' }}
      >
        {props.left && (
          <path
            d="M0.867189 8.83594C0.515626 9.1875 0.515626 9.77344 0.867188 10.125L8.44531 17.7422C8.83594 18.0937 9.42188 18.0937 9.77344 17.7422L10.6719 16.8437C11.0234 16.4922 11.0234 15.9062 10.6719 15.5156L4.65625 9.5L10.6719 3.44531C11.0234 3.05469 11.0234 2.46875 10.6719 2.11719L9.77344 1.21875C9.42188 0.867187 8.83594 0.867187 8.44531 1.21875L0.867189 8.83594Z"
            fill="#195178"
          />
        )}
        {!props.left && (
          <path
            d="M12.916 12.4551C13.3555 12.0156 13.3555 11.2832 12.916 10.8438L3.44336 1.32227C2.95508 0.882812 2.22266 0.882812 1.7832 1.32227L0.660156 2.44531C0.220703 2.88477 0.220703 3.61719 0.660156 4.10547L8.17969 11.625L0.660156 19.1934C0.220703 19.6816 0.220703 20.4141 0.660156 20.8535L1.7832 21.9766C2.22266 22.416 2.95508 22.416 3.44336 21.9766L12.916 12.4551Z"
            fill="#195178"
          />
        )}
      </svg>
    </Above>
  )
}

export const BaseCarousel = ({ children, settings }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)
  
  const childrenArray = React.Children.toArray(children)
  const perView = settings.perView || 1
  const totalSlides = childrenArray.length
  const showArrows = settings.showArrows && totalSlides > perView
  
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      mode: "free",
      slides: {
        perView: settings.perView,
        spacing: settings.spacing,
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel)
      },
      created() {
        setLoaded(true)
      },
    },
    [
      // add plugins here
    ]
  )

  const nextSlide = (e) => {
    e.stopPropagation()
    if (instanceRef.current) {
      const nextIndex = Math.min(currentSlide + perView, childrenArray.length - perView)
      instanceRef.current.moveToIdx(nextIndex)
    }
  }

  const prevSlide = (e) => {
    e.stopPropagation()
    if (instanceRef.current) {
      const prevIndex = Math.max(currentSlide - perView, 0)
      instanceRef.current.moveToIdx(prevIndex)
    }
  }

  const isAtStart = currentSlide === 0
  const isAtEnd = currentSlide >= childrenArray.length - perView

  return (
    <CarouselWrapper className="keen-slider-wrapper">
      <div ref={sliderRef} className="keen-slider">
        {children}
      </div>
      
      {showArrows && loaded && instanceRef.current && (
        <ArrowWrapper>
          <Arrow
            left
            onClick={prevSlide}
            disabled={isAtStart}
          />
          <Arrow
            onClick={nextSlide}
            disabled={isAtEnd}
          />
        </ArrowWrapper>
      )}
    </CarouselWrapper>
  )
}